/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unknown-property */
import {
  useState, useEffect, useContext, useCallback, memo, lazy, Suspense,
} from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';

// For Login Functionality
import Cookies from 'js-cookie';
import {
  AppBar,
  Avatar,
  Box,
  Button,
  ClickAwayListener,
  Container,
  Divider,
  Fade,
  Grid,
  List,
  ListItem,
  Modal,
  Slide,
  Typography,
  useMediaQuery,
  useScrollTrigger,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import { UserContext } from '@context/UserContext';
import { userLogout } from '@shared/services/shareAuthenticationApi';
import KumuLogo from '@assets/images/kumu_logo.png';
// Helpers
import NumberWithCommas from '@shared/utils/NumberWithCommas';
import StringTruncate from '@shared/utils/StringTruncate';
import ButtonLoadingIndicator from '@shared/components/ButtonLoadingIndicator/ButtonLoadingIndicator';

import logo from '@assets/images/kumu-live-logo.png';
import coin from '@assets/images/coin-logo.png';
import SearchIcon from '@features/NavbarSearch';

// Coins Context
import { StreamSegmentContext } from '@services/context/CoinsContext';

// IMPORTING ICONS

import AddSegment from '@shared/utils/Segment';
import './NavBar.css';
import unsetSegmentIdentity from '@shared/utils/UnsetSegmentIdentity';

const LoginModalComponent = lazy(() => import('@features/Authentication'));

// LOCAL-STYLING
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  menu: {
    '& .MuiPaper-root': {
      backgroundColor: '#271D58',
      color: '#FFFFFF',
      marginTop: '10px',
    },
  },
  avatar: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  smallAvatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  link: {
    color: '#FFFFF',
  },
  // Modal
  logoutModal: {
    position: 'absolute',
    height: 200,
    width: 320,
    [theme.breakpoints.down('xs')]: {
      width: 300,
    },
    outline: 0,
    background: '#FFF',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2),
    borderRadius: 4,
  },

}));

function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction='down' in={!trigger}>
      {children}
    </Slide>
  );
}

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

function Navbar(props) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isDesktop = useMediaQuery(theme.breakpoints.down('lg'));
  const history = useHistory();
  const location = useLocation();

  // For mobile menu's
  const [showMenuOption, setMenuOption] = useState(false);
  const showMobileMenu = () => setMenuOption(!showMenuOption);
  // Disable scroll when mobile menu click
  if (showMenuOption && (isMobile || isTablet || isDesktop)) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }

  // For Login Functionality
  const [openAvatar, setOpenAvatar] = useState(false);

  const handleClick = () => {
    setOpenAvatar((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpenAvatar(false);
  };

  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);

  const { loggedIn, setLoggedIn } = useContext(UserContext); // profile data - store

  const [clickLogout, setClickLogout] = useState(false);
  const logoutButton = () => [setClickLogout(!clickLogout)];

  const [openModal, setOpenModal] = useState(false); // Modal
  const [loadingLogin, setLoadingLogin] = useState(false); // Login button loading

  const loginModal = () => [setLoadingLogin(!loadingLogin), setOpenModal(!openModal)];
  const [openLogout, setOpenLogout] = useState(false); // Modal
  const logoutModal = () => setOpenLogout(!openLogout);
  const [logoutSpinner, setLogoutSpinner] = useState(false);

  // new functions and side effects for updating states inside the navbar
  const getLoggedInAction = useCallback((data) => {
    setLoggedIn(data.loggedIn);
    setOpenModal(data.modalStatus);
  }, [loggedIn, openModal]);

  const modalActions = useCallback((data) => {
    setOpenModal(data.modalStatus);
  }, [openModal]);

  const navigateToSettings = () => {
    history.push('/settings');
  };
  const navigateToSettingsMobile = () => {
    history.push('/settings');
    setMenuOption(false);
  };

  useEffect(() => {
    if (clickLogout === true) {
      const _token = Cookies.get('token');
      setLogoutSpinner(true);
      userLogout(_token)
        .then((async (response) => {
          if (response.status === 200 && response.data.code === '200') {
            setClickLogout(false);
            setLoggedIn([]);
            // Unset Segment Identity
            unsetSegmentIdentity();
            // remove token we set
            setLogoutSpinner(false);
            setOpenLogout(!openLogout);
            setMenuOption(false);
            window.location.reload();
            Cookies.remove('token');
            Cookies.remove('uid');
            Cookies.remove('X-kumu-Token');
            Cookies.remove('X-kumu-UserId');
            // segment tracking
            if (process.env.REACT_APP_ON_SEGMENT === 'true') {
              const eventName = 'Signed Out';
              window.analytics.track(eventName, {});
            }
          }
        }))
        .catch((error) => {
          console.error(error);
        });
    }
  }, [clickLogout]);

  const loginButtonComponent = () => (
    <Button variant='contained' className='btns btn-red' onClick={!loadingLogin ? loginModal : () => {}} disableRipple disableElevation disabled={!!loadingLogin}>
      {loadingLogin && <ButtonLoadingIndicator />}
      Log-in
    </Button>
  );

  const renderLoginBtn = () => {
    if (!loggedIn.guid) return loginButtonComponent();
    return <Button variant='contained' className='btns btn-red' onClick={logoutModal} disableRipple disableElevation>Logout</Button>;
  };

  const renderListItemAccount = () => {
    if (loggedIn.guid) return <ListItem><span onClick={navigateToSettingsMobile} className='mobile-nav-link'>ACCOUNT SETTINGS</span></ListItem>;
    return null;
  };

  const renderMyWallet = () => {
    if (loggedIn.guid && process.env.REACT_APP_WALLET === 'true') return <ListItem><span onClick={toMyWallet} className='mobile-nav-link'>MY WALLET</span></ListItem>;
    return null;
  };

  const renderListItemCS = () => {
    if (!loggedIn.guid) {
      return (
        <ListItem><a href={creatorStudioUrl} target='_blank' rel='noreferrer' onClick={() => AddSegment('')} style={{ paddingLeft: theme.spacing(2) }}>Creator Studio</a></ListItem>
      );
    }
    return null;
  };

  const renderLinkTagLogin = () => {
    if (!loggedIn.guid) return <div className='mobile-nav-link' onClick={loginModal} style={{ cursor: 'pointer' }}>LOG IN</div>;
    return <div className='mobile-nav-link' onClick={logoutModal} style={{ cursor: 'pointer' }}>LOG OUT</div>;
  };

  const renderProfileDropdown = () => {
    if (!loggedIn.guid) return loginButtonComponent();
    return (
      <>
        {/* user profile upon login */}
        <ClickAwayListener onClickAway={handleClickAway}>
          <Avatar src={loggedIn.avatar} onClick={handleClick} style={{ cursor: 'pointer' }} />
        </ClickAwayListener>
        {/* New Profile Avatar dropdown */}
        {openAvatar && (
          <div className='userdropdown-content'>
            <div onClick={toProfile}>
              <div className='nav-header' onClick={handleClick} style={{ cursor: 'pointer' }}>
                <Avatar src={loggedIn.avatar} style={{ marginRight: '8px' }} />
                <div className='user-text'>
                  <h5>{StringTruncate(loggedIn.username, 16)}</h5>
                  <div className='coins'>
                    <img src={coin} alt='coin' />
                    <div className='coin-count'>
                      &nbsp;
                      {NumberWithCommas(loggedIn.coin)}
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <Divider style={{ backgroundColor: 'white', opacity: '0.2' }} />

            <div className='nav-body' style={{ fontSize: '16px' }}>
              <ul>
                <a href={creatorStudioUrl} target='_blank' rel='noreferrer'><li>Creator Studio</li></a>
                <li><span onClick={navigateToSettings} style={{ cursor: 'pointer' }}>Account Settings</span></li>
                { (loggedIn.guid && process.env.REACT_APP_WALLET === 'true')
                        && (<li><span onClick={toMyWallet} style={{ cursor: 'pointer' }}>My Wallet</span></li>)}
              </ul>
            </div>
            <Divider style={{ backgroundColor: 'white', opacity: '0.2' }} />

            <div className='nav-footer' style={{ fontSize: '16px', cursor: 'pointer' }}>
              <ul>
                <span onClick={logoutModal}><li>Log-out</li></span>
              </ul>
            </div>
          </div>
        )}
      </>
    );
  };

  const logoutPopup = (
    <div style={modalStyle} className={classes.logoutModal}>

      <Grid container>
        <Grid container alignItems='center' justifyContent='flex-start' style={{ marginBottom: '14px' }}>
          <Typography style={{ color: 'black', fontSize: '18px' }}>Ready to Leave?</Typography>
          <CloseIcon className='close-icon' fontSize='small' onClick={logoutModal} style={{ color: '#000', opacity: '0.5', marginLeft: 'auto' }} />
        </Grid>
        <Grid item xs={12}>
          <Divider style={{ backgroundColor: '#e9ecef' }} />
          <Typography style={{ color: '#808080', fontSize: '14px', padding: '14px 0' }}>Select "Logout" below if you are ready to end your current session.</Typography>
          <Divider style={{ backgroundColor: '#e9ecef' }} />
        </Grid>

        <Grid item xs={12}>
          <Grid container alignItems='center' justifyContent='flex-end' style={{ marginTop: '16px' }}>
            <Button
              variant='contained'
              onClick={logoutModal}
              disableRipple
              disableElevation
              style={{
                background: 'linear-gradient(135deg,#9ba8aa 0,#92b4d2 100%)', color: '#FFF', borderRadius: '25px', textTransform: 'capitalize',
              }}
            >
              Cancel
            </Button>
            {' '}
              &nbsp;
            <Button
              variant='contained'
              onClick={logoutButton}
              disableRipple
              disableElevation
              style={{
                background: '#fb2861', color: '#FFF', width: 'auto', borderRadius: '25px', textTransform: 'capitalize',
              }}
            >
              {logoutSpinner ? <ButtonLoadingIndicator /> : null }
              Logout
            </Button>
          </Grid>
        </Grid>

      </Grid>

    </div>
  );

  let creatorStudioUrl = process.env.REACT_APP_DASHBOARD_URL;
  const browseLink = '/live';
  const oldCoinsLink = process.env.REACT_APP_COINS_BASE_URL;

  const { segmentCoinsContext, setSegmentCoinsContext } = useContext(StreamSegmentContext);
  const toCoins = () => {
    if (process.env.REACT_APP_COINS_REFACTOR === 'true') {
      // clear data from context
      // store it instead in History
      const segmentCoinsData = segmentCoinsContext;
      setSegmentCoinsContext({});
      history.push('/coins', { pathName: window.location.pathname, segmentCoinsContext: segmentCoinsData });
      setMenuOption(false);
    } else {
      window.location.href = oldCoinsLink;
    }
  };

  const toMyWallet = () => {
    history.push('/wallet', { prevRoute: location.pathname });
    setMenuOption(false);
  };

  const toProfile = () => {
    history.push('/', loggedIn.username);
  };

  const toBrowse = () => {
    AddSegment('');
    history.push(browseLink);
  };

  // const toRL = () => {
  //   AddSegment('');
  //   history.push('/referral-leaderboard');
  // };

  const handleHomepageRedirection = () => {
    history.push('/');
  };

  return (
    <Suspense fallback={(
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh',
      }}
      >
        <div className='loader-navbar'>
          <img alt='logo' src={KumuLogo} width='50' height='auto' />
        </div>
      </div>
    )}
    >
      <div className={classes.root}>
        <HideOnScroll {...props}>
          <AppBar className='navbar' position='relative'>
            <Grid container alignItems='center' justifyContent='space-between'>
              <Grid item md={1}>
                <div onClick={handleHomepageRedirection} className='navbar-brand'>
                  <img className='logo' src={logo} alt='logo' width='80' height='auto' />
                </div>
              </Grid>
              {isTablet ? (
                <>
                  <Grid item className='search-bar-container'>
                    {location.pathname !== '/search/index' && <SearchIcon />}
                    <Button variant='contained' className='btns btn-yellow btn-yellow-coins' onClick={toCoins} target='_blank' disableRipple disableElevation>
                      <img src={coin} alt='coin' className='coin' />
                      Buy Coins
                    </Button>
                    <MenuIcon className='mobile-nav-icon' onClick={showMobileMenu} />
                  </Grid>

                  {showMenuOption && (
                    <Container className='mobile-nav'>
                      <Grid container>
                        <Grid item xs={12} sm={12}>
                          <Grid container justifyContent='flex-end' style={{ marginTop: '16px' }}>
                            <CloseIcon className='mobile-nav-icon' onClick={showMobileMenu} fontSize='large' style={{ marginRight: '6px' }} />
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <Grid container justifyContent='center'>
                            { renderLoginBtn() }
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <List component='nav' aria-labelledby='nested-list-subheader' style={{ marginLeft: theme.spacing(1) }}>
                            <ListItem>
                              <div className='mobile-nav-link' component={Link} onClick={toBrowse}>BROWSE</div>
                            </ListItem>
                            <ListItem><a href='/referral-leaderboard' rel='noreferrer' onClick={() => AddSegment('')} style={{ paddingLeft: theme.spacing(2) }}>Referral Leaderboard</a></ListItem>
                            { renderListItemAccount() }
                            { renderMyWallet() }
                            { renderListItemCS() }
                            <ListItem>
                              { renderLinkTagLogin() }
                            </ListItem>
                          </List>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <Grid container alignItems='center' justifyContent='center'>
                            <div className='mobile-menu-logo' onClick={toBrowse}>
                              <img src={logo} alt='logo' height='30' width='60' />
                            </div>
                          </Grid>
                        </Grid>

                      </Grid>
                    </Container> // End Container
                  )}
                </>
              ) : (
                <>
                  <Grid item md={5} lg={5} justifyContent='flex-start'>
                    <Box display='flex' justifyContent='flex-start' alignItems='left'>
                      <div className='nav-link' onClick={toBrowse} component={Link} style={{ cursor: 'pointer' }}>Browse</div>
                    </Box>
                  </Grid>
                  <Grid item container md={6} lg={6} className='search-bar-container' justifyContent='flex-end' wrap='nowrap' alignItems='center'>
                    {location.pathname !== '/search/index' && <SearchIcon />}
                    <Button variant='contained' className='btns btn-yellow' onClick={toCoins} disableRipple disableElevation>
                      <img src={coin} alt='coin' className='coin' />
                      Buy Coins
                    </Button>
                    { renderProfileDropdown() }
                  </Grid>
                </>
              )}

            </Grid>
          </AppBar>
        </HideOnScroll>
      </div>
      { openModal
        ? (
          <LoginModalComponent
            isOpenModal={openModal}
            modalFunc={modalActions}
            loggedInFunc={getLoggedInAction}
            showMobileMenu={showMobileMenu}
            showMenuOption={showMenuOption}
            setMenuOption={setMenuOption}
            isOpenReCaptcha={props.isOpenReCaptcha}
            setLoadingLogin={setLoadingLogin}
          />
        ) : null}
      <Modal
        open={openLogout}
        onClose={logoutModal}
        aria-labelledby='modal-title'
        aria-describedby='modal-description'
      >
        <Fade in={openLogout}>
          {logoutPopup}
        </Fade>
      </Modal>
    </Suspense>
  );
}

export default memo(Navbar);
